import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteStatus } from '../context/SiteStatusContext';

const BLOCK_CONTENT = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
const META_NAMES = ['robots', 'googlebot', 'bingbot'];

/**
 * When coming soon is on, inject noindex meta on all public SPA routes
 * (including legal pages) so crawlers that reach index.html do not index.
 */
export default function RobotsMetaManager() {
  const { comingSoonEnabled, loading } = useSiteStatus();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const isAgent = pathname.startsWith('/agent');
  const shouldBlock = !loading && comingSoonEnabled && !isAdmin && !isAgent;

  useEffect(() => {
    if (isAdmin || isAgent) return undefined;

    const touched = [];

    META_NAMES.forEach((name) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (shouldBlock) {
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('name', name);
          el.dataset.acfComingSoonAdded = '1';
          document.head.appendChild(el);
        } else if (!el.dataset.acfComingSoonPrev) {
          el.dataset.acfComingSoonPrev = el.getAttribute('content') || '';
        }
        el.setAttribute('content', BLOCK_CONTENT);
        touched.push(el);
      } else if (el) {
        if (el.dataset.acfComingSoonAdded === '1') {
          el.remove();
        } else if (el.dataset.acfComingSoonPrev !== undefined) {
          const prev = el.dataset.acfComingSoonPrev;
          if (prev) el.setAttribute('content', prev);
          else el.removeAttribute('content');
          delete el.dataset.acfComingSoonPrev;
        }
      }
    });

    return () => {
      touched.forEach((el) => {
        if (el.dataset.acfComingSoonAdded === '1' && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    };
  }, [shouldBlock, isAdmin, isAgent]);

  return null;
}
